var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-keyword"},[_c('img',{attrs:{"src":require("@/assets/icon/search.svg")}}),_c('input',{staticClass:"form-control",attrs:{"type":"text","name":"keyword","maxlength":"20","placeholder":_vm.placeholder},domProps:{"value":_vm.keyword},on:{"keyup":_vm.updateKeyword}})])
}
var staticRenderFns = []

export { render, staticRenderFns }